import icProgramStage from "@/assets/images/user/icProgramStage.svg";
import programStageCont1Img1 from "@/assets/images/user/programStageCont1Img1.jpg";
import programStageCont2Img1 from "@/assets/images/user/programStageCont2Img1.jpg";
import programStageCont2Img2 from "@/assets/images/user/programStageCont2Img2.jpg";
import programStageCont2Img3 from "@/assets/images/user/programStageCont2Img3.jpg";
import programStageCont3Img1 from "@/assets/images/user/programStageCont3Img1.jpg";
import programStageCont3Img2 from "@/assets/images/user/programStageCont3Img2.jpg";
import programStageCont3Img3 from "@/assets/images/user/programStageCont3Img3.jpg";
import programStageCont3Img4 from "@/assets/images/user/programStageCont3Img4.jpg";
import programStageCont3Img5 from "@/assets/images/user/programStageCont3Img5.jpg";
import programStageCont3Img6 from "@/assets/images/user/programStageCont3Img6.jpg";
import programStageCont3Img7 from "@/assets/images/user/programStageCont3Img7.jpg";
import programStageCont4Img1 from "@/assets/images/user/programStageCont4Img1.jpg";
import programStageCont4Img2 from "@/assets/images/user/programStageCont4Img2.jpg";
import programStageCont4Img3 from "@/assets/images/user/programStageCont4Img3.jpg";
import programStageCont4Img4 from "@/assets/images/user/programStageCont4Img4.jpg";
import programStageCont4Img5 from "@/assets/images/user/programStageCont4Img5.jpg";
import programStageCont4Img6 from "@/assets/images/user/programStageCont4Img6.jpg";
import programStageCont4Img7 from "@/assets/images/user/programStageCont4Img7.jpg";
import programStageCont5Img1 from "@/assets/images/user/programStageCont5Img1.jpg";
import programStageCont5Img2 from "@/assets/images/user/programStageCont5Img2.jpg";
import programStageCont6Img1 from "@/assets/images/user/programStageCont6Img1.jpg";
import programStageCont6Img2 from "@/assets/images/user/programStageCont6Img2.jpg";
import programStageCont6Img3 from "@/assets/images/user/programStageCont6Img3.jpg";
import programStageCont7Day1Img1 from "@/assets/images/user/programStageCont7Day1Img1.jpg";
import programStageCont7Day1Img2 from "@/assets/images/user/programStageCont7Day1Img2.jpg";
import programStageCont7Day1Img3 from "@/assets/images/user/programStageCont7Day1Img3.jpg";
import programStageCont7Day1Img4 from "@/assets/images/user/programStageCont7Day1Img4.jpg";
import programStageCont7Day1Img5 from "@/assets/images/user/programStageCont7Day1Img5.jpg";
import programStageCont7Day1Img6 from "@/assets/images/user/programStageCont7Day1Img6.jpg";
import programStageCont7Day1Img7 from "@/assets/images/user/programStageCont7Day1Img7.jpg";
import programStageCont7Day2Img1 from "@/assets/images/user/programStageCont7Day2Img1.jpg";
import programStageCont7Day2Img2 from "@/assets/images/user/programStageCont7Day2Img2.jpg";
import programStageCont7Day2Img3 from "@/assets/images/user/programStageCont7Day2Img3.jpg";
import programStageCont7Day2Img4 from "@/assets/images/user/programStageCont7Day2Img4.jpg";
import programStageCont7Day2Img5 from "@/assets/images/user/programStageCont7Day2Img5.jpg";
import programStageCont7Day2Img6 from "@/assets/images/user/programStageCont7Day2Img6.jpg";
import programStageCont7Day2Img7 from "@/assets/images/user/programStageCont7Day2Img7.jpg";
import programStageCont7Day2Img8 from "@/assets/images/user/programStageCont7Day2Img8.jpg";
import programStageCont7Day2Img9 from "@/assets/images/user/programStageCont7Day2Img9.jpg";
import programStageCont7Img1 from "@/assets/images/user/programStageCont7Img1.jpg";
import programStageCont8Img1 from "@/assets/images/user/programStageCont8Img1.jpg";
// import programStageCont8Img2 from "@/assets/images/user/programStageCont8Img2.jpg";
// import programStageCont8Img3 from "@/assets/images/user/programStageCont8Img3.jpg";
import programStageTimeTable from "@/assets/images/user/programStageTimeTable.jpg";
import programStageTimeTableTb from "@/assets/images/user/programStageTimeTableTb.jpg";
import ProgramAccordion from "@/components/user/common/ProgramAccordion";
import SubTitle from "@/components/user/common/SubTitle";
import ImgZoomPop from "@/components/user/popup/ImgZoomPop";

const txtBoxClass =
    "max-w-[72px] w-full text-[16px] py-[4px] text-[#000] font-['GongGothicMedium'] text-center leading-[25px] rounded-[8px] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] border border-transparent [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] [background-clip:padding-box,border-box] md:max-w-[120px] md:text-[20px] md:py-[10px]";
const txtGradientClass = "bg-gradient-to-r from-[#DE548E] to-[#C63270] bg-clip-text text-transparent";
const txtGradientClass2 = "bg-gradient-to-r from-[#FF5B2E] to-[#FF7F71] bg-clip-text text-transparent";

const programList = [
    {
        title: "사전 공연 : 리프(Lif)",
        background: "bg-program202501",
        img: icProgramStage,
        contents: (
            <div className="flex flex-col gap-[16px] md:gap-[40px] xl:flex-row xl:gap-0">
                <ul className="flex flex-col gap-[16px] md:gap-[24px] xl:flex-1">
                    <li className="flex items-center gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>일시</p>
                        <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                            Day 1 : 9/19(금), 17:30 ~ 18:00
                        </p>
                    </li>
                    <li className="flex items-center gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>장소</p>
                        <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                            판교역 중앙광장 - 메인 스테이지
                        </p>
                    </li>
                    <li className="flex items-start gap-[8px] md:gap-[20px] md:items-center">
                        <p className={txtBoxClass}>내용</p>
                        <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                            GXG 2025의 시작을 알리는 <br className="md:hidden" />
                            사전 축하 공연 <br />제 1회 게임음악경연대회 우승팀 밴드 리프 (Lif)의 공연을 즐겨보세요!
                        </p>
                    </li>
                </ul>
                <div className="w-full md:w-[calc(50%-10px)] xl:w-1/3">
                    <img src={programStageCont1Img1} alt="이미지" className="w-full" />
                </div>
            </div>
        ),
    },
    {
        title: "GXG 2025 개막식&축하 공연",
        background: "bg-program202501",
        img: icProgramStage,
        contents: (
            <ul className="flex flex-col gap-[16px] md:gap-[24px]">
                <li className="flex items-center gap-[8px] md:gap-[20px]">
                    <p className={txtBoxClass}>일시</p>
                    <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                        Day 1 : 9/19(금), 18:00 ~ 19:00
                    </p>
                </li>
                <li className="flex items-center gap-[8px] md:gap-[20px]">
                    <p className={txtBoxClass}>장소</p>
                    <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                        판교역 중앙광장 - 메인 스테이지
                    </p>
                </li>
                <li className="flex items-start gap-[8px] md:gap-[20px] md:items-center">
                    <p className={txtBoxClass}>내용</p>
                    <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                        GXG 2025의 시작을 알리는 <br className="md:hidden" />
                        개막 세리머니와 함께 <br />
                        대한민국 대표 디바, 에일리의 <br className="md:hidden" />
                        파워풀한 축하 공연이 펼쳐집니다.
                    </p>
                </li>
                <li className="flex flex-col gap-[16px] md:gap-[40px]">
                    <div className="flex items-center gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>MC</p>
                        <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                            김규환 캐스터, 최시은 아나운서
                        </p>
                    </div>
                    <ul className="flex flex-wrap gap-[8px] md:gap-[20px]">
                        <li className="w-[calc(50%-4px)] md:w-[calc(50%-10px)] xl:w-[calc(33.333%-13.333px)]">
                            <img src={programStageCont2Img1} alt="이미지" className="w-full" />
                        </li>
                        <li className="w-[calc(50%-4px)] md:w-[calc(50%-10px)] xl:w-[calc(33.333%-13.333px)]">
                            <img src={programStageCont2Img2} alt="이미지" className="w-full" />
                        </li>
                    </ul>
                </li>
                <li className="flex flex-col gap-[16px] md:gap-[40px]">
                    <div className="flex items-center gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>축하 공연</p>
                        <p className="text-[16px] te xt-black flex-1 font-['GongGothicLight'] md:text-[18px]">에일리</p>
                    </div>
                    <ul className="flex flex-wrap gap-[8px] md:gap-[20px]">
                        <li className="w-[calc(50%-4px)] md:w-[calc(50%-10px)] xl:w-[calc(33.333%-13.333px)]">
                            <img src={programStageCont2Img3} alt="이미지" className="w-full" />
                        </li>
                    </ul>
                </li>
            </ul>
        ),
    },
    {
        title: (
            <p className="flex">
                The 2<span className="text-[12px] md:text-[18px] font-['GongGothicLight']">nd&nbsp;</span>GXG SOUND
                TRACK
            </p>
        ),
        background: "bg-program202501",
        img: icProgramStage,
        contents: (
            <ul className="flex flex-col gap-[16px] md:gap-[24px]">
                <li className="flex items-center gap-[8px] md:gap-[20px]">
                    <p className={txtBoxClass}>일시</p>
                    <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                        Day 1 : 9/19(금), 19:00 ~ 21:30
                    </p>
                </li>
                <li className="flex items-center gap-[8px] md:gap-[20px]">
                    <p className={txtBoxClass}>장소</p>
                    <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                        판교역 중앙광장 - 메인 스테이지
                    </p>
                </li>
                <li className="flex flex-col gap-[16px] md:gap-[40px]">
                    <div className="flex items-start gap-[8px] md:gap-[20px] md:items-center">
                        <p className={txtBoxClass}>내용</p>
                        <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                            게임을 모티브로 한 창작곡을 <br className="md:hidden" />
                            감상하고, 현장 투표에도 <br className="md:hidden" />
                            직접 참여해 보세요. <br />
                            본선에 오른 7팀의 멋진 무대가 <br className="md:hidden" />
                            시작됩니다.
                        </p>
                    </div>
                    <ul className="flex flex-col gap-[16px] md:flex-row md:gap-[20px] md:flex-wrap">
                        <li className="w-full md:w-[calc(50%-10px)] xl:w-[calc(25%-15px)]">
                            <img src={programStageCont3Img1} alt="이미지" className="w-full" />
                            <div className="bg-[#F1F4F9] p-[20px] flex flex-col gap-[8px] text-center md:p-[20px_10px]">
                                <p className={`text-[20px] ${txtGradientClass} md:text-[24px]`}>
                                    <span className="font-['GongGothicMedium']">ON:</span>
                                    <span className="font-[500]">明</span>
                                </p>
                                <p className="text-[18px] md:text-[20px]">
                                    <span className="font-['GongGothicLight']">여명:</span>
                                    <span className="font-[300]">&nbsp;舁明&nbsp;</span>- 검은사막
                                </p>
                            </div>
                        </li>
                        <li className="w-full md:w-[calc(50%-10px)] xl:w-[calc(25%-15px)]">
                            <img src={programStageCont3Img2} alt="이미지" className="w-full" />
                            <div className="bg-[#F1F4F9] p-[20px] flex flex-col gap-[8px] text-center md:p-[20px_10px]">
                                <p
                                    className={`text-[20px] font-['GongGothicMedium'] md:text-[24px] ${txtGradientClass}`}
                                >
                                    겜블러
                                </p>
                                <p className="text-[18px] font-['GongGothicLight'] md:text-[20px]">
                                    잭팟! - 모바일 한게임 포커
                                </p>
                            </div>
                        </li>
                        <li className="w-full md:w-[calc(50%-10px)] xl:w-[calc(25%-15px)]">
                            <img src={programStageCont3Img3} alt="이미지" className="w-full" />
                            <div className="bg-[#F1F4F9] p-[20px] flex flex-col gap-[8px] text-center md:p-[20px_10px]">
                                <p
                                    className={`text-[20px] font-['GongGothicMedium'] md:text-[24px] ${txtGradientClass}`}
                                >
                                    볼따구프렌즈
                                </p>
                                <p className="text-[18px] font-['GongGothicLight'] md:text-[20px]">
                                    Be fine! - 트릭컬 리바이브
                                </p>
                            </div>
                        </li>
                        <li className="w-full md:w-[calc(50%-10px)] xl:w-[calc(25%-15px)]">
                            <img src={programStageCont3Img4} alt="이미지" className="w-full" />
                            <div className="bg-[#F1F4F9] p-[20px] flex flex-col gap-[8px] text-center md:p-[20px_10px]">
                                <p
                                    className={`text-[20px] font-['GongGothicMedium'] md:text-[24px] ${txtGradientClass}`}
                                >
                                    EZ DO BAND
                                </p>
                                <p className="text-[18px] font-['GongGothicLight'] md:text-[20px]">
                                    Sync or Sink - 리그오브레전드
                                </p>
                            </div>
                        </li>
                        <li className="w-full md:w-[calc(50%-10px)] xl:w-[calc(25%-15px)]">
                            <img src={programStageCont3Img5} alt="이미지" className="w-full" />
                            <div className="bg-[#F1F4F9] p-[20px] flex flex-col gap-[8px] text-center md:p-[20px_10px]">
                                <p
                                    className={`text-[20px] font-['GongGothicMedium'] md:text-[24px] ${txtGradientClass}`}
                                >
                                    버닝
                                </p>
                                <p className="text-[18px] font-['GongGothicLight'] md:text-[20px]">
                                    두고 봐 빛날거야 - 메이플스토리
                                </p>
                            </div>
                        </li>
                        <li className="w-full md:w-[calc(50%-10px)] xl:w-[calc(25%-15px)]">
                            <img src={programStageCont3Img6} alt="이미지" className="w-full" />
                            <div className="bg-[#F1F4F9] p-[20px] flex flex-col gap-[8px] text-center md:p-[20px_10px]">
                                <p
                                    className={`text-[20px] font-['GongGothicMedium'] md:text-[24px] ${txtGradientClass}`}
                                >
                                    Band 203
                                </p>
                                <p className="text-[18px] font-['GongGothicLight'] md:text-[20px]">Up! - 브롤스타즈</p>
                            </div>
                        </li>
                        <li className="w-full md:w-[calc(50%-10px)] xl:w-[calc(25%-15px)]">
                            <img src={programStageCont3Img7} alt="이미지" className="w-full" />
                            <div className="bg-[#F1F4F9] p-[20px] flex flex-col gap-[8px] text-center md:p-[20px_10px]">
                                <p
                                    className={`text-[20px] font-['GongGothicMedium'] md:text-[24px] ${txtGradientClass}`}
                                >
                                    우주골치클럽
                                </p>
                                <p className="text-[18px] font-['GongGothicLight'] md:text-[20px]">
                                    Hollow`s puppet - P의 거짓
                                </p>
                            </div>
                        </li>
                    </ul>
                </li>
            </ul>
        ),
    },
    {
        title: "일러스타 페스 STAGE",
        background: "bg-program202501",
        img: icProgramStage,
        contents: (
            <div className="flex flex-col gap-[16px] md:gap-[40px]">
                <div className="flex flex-col gap-[16px] md:gap-[40px] xl:flex-row xl:gap-0">
                    <ul className="flex flex-col gap-[16px] md:gap-[24px] xl:flex-1">
                        <li className="flex items-center gap-[8px] md:gap-[20px]">
                            <p className={txtBoxClass}>일시</p>
                            <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                                Day 2 : 9/20(토), 12:00 ~ 15:00
                            </p>
                        </li>
                        <li className="flex items-center gap-[8px] md:gap-[20px]">
                            <p className={txtBoxClass}>장소</p>
                            <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                                판교역 중앙광장 - 메인 스테이지
                            </p>
                        </li>
                        <li className="flex items-start gap-[8px] md:gap-[20px] md:items-center">
                            <p className={txtBoxClass}>내용</p>
                            <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18p x]">
                                서브컬처의 트렌드를 이끄는 <br className="md:hidden" />
                                인디 아이돌의 공연부터 <br />
                                눈길을 사로잡는 코스튬 플레이어의 <br className="md:hidden" />
                                무대까지! <br />
                                일러스타 페스의 열기를 <br className="md:hidden" />
                                GXG 2025에서 느껴보세요.
                            </p>
                        </li>
                    </ul>
                    <div className="w-full md:w-[calc(50%-10px)] xl:w-1/3">
                        <img src={programStageCont4Img1} alt="이미지" className="w-full" />
                    </div>
                </div>
                <ul>
                    <li className="flex flex-col gap-[20px]">
                        <p className={txtBoxClass}>출연</p>
                        <div className="flex flex-col gap-[8px]">
                            <p className="font-['GongGothicMedium'] text-[20px] md:text-[24px]">코스플레이</p>
                            <p className="font-['GongGothicLight'] text-[16px] md:text-[18px]">
                                점프는 기세야!, 무테키노아이도루, 와쿠와쿠 로드, 보카로 사이에 피어난 루카, 미쿠&렌
                                스트릿, 댄스댄스비배스
                            </p>
                        </div>
                        <p className="font-['GongGothicMedium'] text-[20px] md:text-[24px]">인디아이돌</p>
                        <ul className="flex flex-col gap-[16px] md:flex-row md:gap-[20px] md:flex-wrap">
                            <li className="w-full md:w-[calc(50%-10px)] xl:w-[calc(33.333%-13.333px)]">
                                <img src={programStageCont4Img2} alt="이미지" className="w-full" />
                                <div className="bg-[#F1F4F9] p-[20px] text-center md:p-[20px_10px]">
                                    <p
                                        className={`text-[20px] font-['GongGothicMedium'] md:text-[24px] ${txtGradientClass}`}
                                    >
                                        Memoria
                                    </p>
                                </div>
                            </li>
                            <li className="w-full md:w-[calc(50%-10px)] xl:w-[calc(33.333%-13.333px)]">
                                <img src={programStageCont4Img3} alt="이미지" className="w-full" />
                                <div className="bg-[#F1F4F9] p-[20px] text-center md:p-[20px_10px]">
                                    <p
                                        className={`text-[20px] font-['GongGothicMedium'] md:text-[24px] ${txtGradientClass}`}
                                    >
                                        IDOL COLLECTION
                                    </p>
                                </div>
                            </li>
                            <li className="w-full md:w-[calc(50%-10px)] xl:w-[calc(33.333%-13.333px)]">
                                <img src={programStageCont4Img4} alt="이미지" className="w-full" />
                                <div className="bg-[#F1F4F9] p-[20px] text-center md:p-[20px_10px]">
                                    <p
                                        className={`text-[20px] font-['GongGothicMedium'] md:text-[24px] ${txtGradientClass}`}
                                    >
                                        우고프페
                                    </p>
                                </div>
                            </li>
                            <li className="w-full md:w-[calc(50%-10px)] xl:w-[calc(33.333%-13.333px)]">
                                <img src={programStageCont4Img5} alt="이미지" className="w-full" />
                                <div className="bg-[#F1F4F9] p-[20px] text-center md:p-[20px_10px]">
                                    <p
                                        className={`text-[20px] font-['GongGothicMedium'] md:text-[24px] ${txtGradientClass}`}
                                    >
                                        H7KD
                                    </p>
                                </div>
                            </li>
                            <li className="w-full md:w-[calc(50%-10px)] xl:w-[calc(33.333%-13.333px)]">
                                <img src={programStageCont4Img6} alt="이미지" className="w-full" />
                                <div className="bg-[#F1F4F9] p-[20px] text-center md:p-[20px_10px]">
                                    <p
                                        className={`text-[20px] font-['GongGothicMedium'] md:text-[24px] ${txtGradientClass}`}
                                    >
                                        REKIREM
                                    </p>
                                </div>
                            </li>
                            <li className="w-full md:w-[calc(50%-10px)] xl:w-[calc(33.333%-13.333px)]">
                                <img src={programStageCont4Img7} alt="이미지" className="w-full" />
                                <div className="bg-[#F1F4F9] p-[20px] text-center md:p-[20px_10px]">
                                    <p
                                        className={`text-[20px] font-['GongGothicMedium'] md:text-[24px] ${txtGradientClass}`}
                                    >
                                        IHOTEU
                                    </p>
                                </div>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        ),
    },
    {
        title: "GXG 플레이 타임",
        background: "bg-program202501",
        img: icProgramStage,
        contents: (
            <ul className="flex flex-col gap-[16px] md:gap-[24px]">
                <li className="flex items-center gap-[8px] md:gap-[20px]">
                    <p className={txtBoxClass}>일시</p>
                    <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                        Day 2 : 9/20(토), 15:30 ~ 17:30
                    </p>
                </li>
                <li className="flex items-center gap-[8px] md:gap-[20px]">
                    <p className={txtBoxClass}>장소</p>
                    <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                        판교역 중앙광장 - 메인 스테이지
                    </p>
                </li>
                <li className="flex items-start gap-[8px] md:gap-[20px] md:items-center">
                    <p className={txtBoxClass}>내용</p>
                    <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                        세대를 초월한 콘솔 게임 명작 대전, <br />
                        승리의 영광과 함께 경품을 <br className="md:hidden" />
                        차지하세요!
                    </p>
                </li>
                <li className="flex flex-col gap-[16px] md:gap-[40px]">
                    <div className="flex items-center gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>MC</p>
                        <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                            김규환 캐스터, 최시은 아나운서
                        </p>
                    </div>
                    <ul className="flex flex-wrap gap-[8px] md:gap-[20px]">
                        <li className="w-[calc(50%-4px)] md:w-[calc(50%-10px)] xl:w-[calc(33.333%-13.333px)]">
                            <img src={programStageCont5Img1} alt="이미지" className="w-full" />
                        </li>
                        <li className="w-[calc(50%-4px)] md:w-[calc(50%-10px)] xl:w-[calc(33.333%-13.333px)]">
                            <img src={programStageCont5Img2} alt="이미지" className="w-full" />
                        </li>
                    </ul>
                </li>
                <li className="flex items-start gap-[8px] md:gap-[20px]">
                    <p className={txtBoxClass}>참여</p>
                    <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                        9월 20일 현장 신청자 중 추첨을 통해 선정된 관람객 <br />
                        - 이벤트 등록 신청은 GXG 2025 중앙광장 인포메이션 부스 <br className="md:hidden" />
                        9/20(토) 13:00 ~ 14:30 운영 예정 <br />
                        - 신청자 중 현장 추첨을 통해 GXG 플레이 타임 참여 인원이 선발됩니다. <br />
                        *SNS를 통해 현장 신청 안내 예정이며, 현장 상황에 따라 변동될 수 있음
                    </p>
                </li>
                <li className="flex items-start gap-[8px] md:gap-[20px]">
                    <p className={txtBoxClass}>종목</p>
                    <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                        - 오버 쿡드2 (2인 팀전) <br />- 철권 8 *만 15세 이상부터 출전 가능합니다.
                    </p>
                </li>
            </ul>
        ),
    },
    {
        title: "GXG 갈라 콘서트",
        background: "bg-program202501",
        img: icProgramStage,
        contents: (
            <ul className="flex flex-col gap-[16px] md:gap-[24px]">
                <li className="flex items-center gap-[8px] md:gap-[20px]">
                    <p className={txtBoxClass}>일시</p>
                    <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                        Day 2 : 9/20(토), 18:30 ~ 21:30
                    </p>
                </li>
                <li className="flex items-center gap-[8px] md:gap-[20px]">
                    <p className={txtBoxClass}>장소</p>
                    <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                        판교역 중앙광장 - 메인 스테이지
                    </p>
                </li>
                <li className="flex items-start gap-[8px] md:gap-[20px] md:items-center">
                    <p className={txtBoxClass}>내용</p>
                    <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                        GXG 2025의 피날레를 장식할 <br className="md:hidden" />
                        초가을 밤 갈라 콘서트! <br />
                        다채롭게 구현되는 게임 음악을 통해 <br className="md:hidden" />
                        벅찬 감동을 느껴보세요.
                    </p>
                </li>
                <li className="flex flex-col gap-[16px] md:gap-[40px]">
                    <div className="flex items-start gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>출연</p>
                        <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                            - 네오플 장애인 첼로 연주단 <br className="md:hidden" />
                            앙상블 힐(Ensemble Heal) <br />
                            - 플래직 콰이어 - 국내 최초 서브컬처 음악 전문 제작사 ‘플래직’의 합창단 <br />- GXG SOUND
                            TRACK 본선 진출팀
                        </p>
                    </div>
                    <ul className="flex flex-wrap gap-[8px] md:gap-[20px]">
                        <li className="w-[calc(50%-4px)] md:w-[calc(50%-10px)] xl:w-[calc(33.333%-13.333px)]">
                            <img src={programStageCont6Img1} alt="이미지" className="w-full" />
                        </li>
                        <li className="w-[calc(50%-4px)] md:w-[calc(50%-10px)] xl:w-[calc(33.333%-13.333px)]">
                            <img src={programStageCont6Img2} alt="이미지" className="w-full" />
                        </li>
                        <li className="w-[calc(50%-4px)] md:w-[calc(50%-10px)] xl:w-[calc(33.333%-13.333px)]">
                            <img src={programStageCont6Img3} alt="이미지" className="w-full" />
                        </li>
                    </ul>
                </li>
            </ul>
        ),
    },
];

const programList2 = [
    {
        title: "GXG 버스킹 타임 - 직장인 밴드",
        background: "bg-program202501",
        img: icProgramStage,
        contents: (
            <div className="flex flex-col gap-[20px] md:gap-[40px]">
                <div className="flex flex-col gap-[16px] md:gap-[40px] xl:flex-row xl:gap-0">
                    <ul className="flex flex-col gap-[16px] md:gap-[24px] xl:flex-1">
                        <li className="flex items-center gap-[8px] md:gap-[20px]">
                            <p className={txtBoxClass}>일시</p>
                            <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                                Day 1 : 9/19(금), 16:00 ~ 21:00 <br />
                                Day 2 : 9/20(토), 16:00 ~ 21:00
                            </p>
                        </li>
                        <li className="flex items-center gap-[8px] md:gap-[20px]">
                            <p className={txtBoxClass}>장소</p>
                            <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                                판교역 북측광장 B - 서브 스테이지
                            </p>
                        </li>
                        <li className="flex items-start gap-[8px] md:gap-[20px] md:items-center">
                            <p className={txtBoxClass}>내용</p>
                            <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                                GXG 2025를 더 특별하게 즐기는 <br className="md:hidden" />
                                방법! <br />
                                각양각색 직장인 밴드의 <br className="md:hidden" />
                                라이브 버스킹을 놓치지 마세요.
                            </p>
                        </li>
                        <li className="flex items-start gap-[8px] md:gap-[20px] md:items-center">
                            <p className={txtBoxClass}>9/19(금)</p>
                            <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                                인헤븐리, 서큐버스, <br className="md:hidden" />
                                만화영화주제가밴드, 국키스텐, <br className="md:hidden" />
                                ADO X CAVO, <br className="xl:hidden" />
                                전원참석, GO-Band
                            </p>
                        </li>
                        <li className="flex items-start gap-[8px] md:gap-[20px] md:items-center">
                            <p className={txtBoxClass}>9/20(토)</p>
                            <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                                사우스캐슬, 대환장 밴드, M8, <br className="md:hidden" />
                                컴투스 밴드, 지수와로그, ED12, T.O.N.E, 인데놀 168, AOB
                            </p>
                        </li>
                    </ul>
                    <div className="w-full md:w-[calc(50%-10px)] xl:w-1/3">
                        <img src={programStageCont7Img1} alt="이미지" className="w-full" />
                    </div>
                </div>
                <div className="flex flex-col gap-[20px]">
                    <p className="text-[18px] font-['GongGothicMedium'] md:text-[28px]">DAY 1</p>
                    <ul className="flex flex-col gap-[16px] md:flex-row md:gap-[20px] md:flex-wrap">
                        <li className="w-full md:w-[calc(50%-10px)] xl:w-[calc(25%-15px)] flex flex-col">
                            <img src={programStageCont7Day1Img1} alt="이미지" className="w-full" />
                            <div className="flex-1 bg-[#F1F4F9] p-[20px] gap-[8px] text-center md:p-[20px_10px]">
                                <p
                                    className={`text-[20px] font-['GongGothicMedium'] md:text-[24px] ${txtGradientClass2}`}
                                >
                                    인헤븐리
                                </p>
                                <p className="text-[18px] font-['GongGothicLight'] md:text-[20px]">
                                    팬심으로 모인 다섯, <br />
                                    GXG에서 열정 폭발! <br />
                                    즐거운 무대 보여드리겠습니다!
                                </p>
                            </div>
                        </li>
                        <li className="w-full md:w-[calc(50%-10px)] xl:w-[calc(25%-15px)] flex flex-col">
                            <img src={programStageCont7Day1Img2} alt="이미지" className="w-full" />
                            <div className="flex-1 bg-[#F1F4F9] p-[20px] gap-[8px] text-center md:p-[20px_10px]">
                                <p
                                    className={`text-[20px] font-['GongGothicMedium'] md:text-[24px] ${txtGradientClass2}`}
                                >
                                    서큐버스
                                </p>
                                <p className="text-[18px] font-['GongGothicLight'] md:text-[20px]">
                                    롹과 팝을 넘나들며 에너지 넘치는 무대를 선사해드리도록 하겠습니다.
                                </p>
                            </div>
                        </li>
                        <li className="w-full md:w-[calc(50%-10px)] xl:w-[calc(25%-15px)] flex flex-col">
                            <img src={programStageCont7Day1Img3} alt="이미지" className="w-full" />
                            <div className="flex-1 bg-[#F1F4F9] p-[20px] flex flex-col gap-[8px] text-center md:p-[20px_10px]">
                                <p
                                    className={`text-[20px] font-['GongGothicMedium'] md:text-[24px] ${txtGradientClass2}`}
                                >
                                    만화영화주제가밴드
                                </p>
                                <p className="text-[18px] font-['GongGothicLight'] md:text-[20px]">
                                    그 시절 우리가 사랑했던 것들로 <br />
                                    당신의 내일을 응원합니다.
                                </p>
                            </div>
                        </li>
                        <li className="w-full md:w-[calc(50%-10px)] xl:w-[calc(25%-15px)] flex flex-col">
                            <img src={programStageCont7Day1Img4} alt="이미지" className="w-full" />
                            <div className="flex-1 bg-[#F1F4F9] p-[20px] flex flex-col gap-[8px] text-center md:p-[20px_10px]">
                                <p
                                    className={`text-[20px] font-['GongGothicMedium'] md:text-[24px] ${txtGradientClass2}`}
                                >
                                    국키스텐
                                </p>
                                <p className="text-[18px] font-['GongGothicLight'] md:text-[20px]">
                                    j-pop, 국내 인디를 좋아하는 <br />
                                    스마일게이트 밴드
                                </p>
                            </div>
                        </li>
                        <li className="w-full md:w-[calc(50%-10px)] xl:w-[calc(25%-15px)] flex flex-col">
                            <img src={programStageCont7Day1Img5} alt="이미지" className="w-full" />
                            <div className="flex-1 bg-[#F1F4F9] p-[20px] flex flex-col gap-[8px] text-center md:p-[20px_10px]">
                                <p
                                    className={`text-[20px] font-['GongGothicMedium'] md:text-[24px] ${txtGradientClass2}`}
                                >
                                    ADO X CAVO
                                </p>
                                <p className="text-[18px] font-['GongGothicLight'] md:text-[20px]">
                                    개성 넘치는 일본 J-POP 가수 <br />
                                    Ado 의 곡을 커버하는 밴드입니다!
                                </p>
                            </div>
                        </li>
                        <li className="w-full md:w-[calc(50%-10px)] xl:w-[calc(25%-15px)] flex flex-col">
                            <img src={programStageCont7Day1Img6} alt="이미지" className="w-full" />
                            <div className="flex-1 bg-[#F1F4F9] p-[20px] flex flex-col gap-[8px] text-center md:p-[20px_10px]">
                                <p
                                    className={`text-[20px] font-['GongGothicMedium'] md:text-[24px] ${txtGradientClass2}`}
                                >
                                    전원참석
                                </p>
                                <p className="text-[18px] font-['GongGothicLight'] md:text-[20px]">
                                    다 모이고 싶지만 쉽지 않은 <br />
                                    직장인 밴드 &#39;전원참석&#39;입니다.
                                </p>
                            </div>
                        </li>
                        <li className="w-full md:w-[calc(50%-10px)] xl:w-[calc(25%-15px)] flex flex-col">
                            <img src={programStageCont7Day1Img7} alt="이미지" className="w-full" />
                            <div className="flex-1 bg-[#F1F4F9] p-[20px] flex flex-col gap-[8px] text-center md:p-[20px_10px]">
                                <p
                                    className={`text-[20px] font-['GongGothicMedium'] md:text-[24px] ${txtGradientClass2}`}
                                >
                                    Go-Band
                                </p>
                                <p className="text-[18px] font-['GongGothicLight'] md:text-[20px]">
                                    하나 되어 전하는 음악, Go-Band!
                                </p>
                            </div>
                        </li>
                    </ul>
                </div>
                <div className="flex flex-col gap-[20px]">
                    <p className="text-[18px] font-['GongGothicMedium'] md:text-[28px]">DAY 2</p>
                    <ul className="flex flex-col gap-[16px] md:flex-row md:gap-[20px] md:flex-wrap">
                        <li className="w-full md:w-[calc(50%-10px)] xl:w-[calc(25%-15px)] flex flex-col">
                            <img src={programStageCont7Day2Img1} alt="이미지" className="w-full" />
                            <div className="flex-1 bg-[#F1F4F9] p-[20px] flex flex-col gap-[8px] text-center md:p-[20px_10px]">
                                <p
                                    className={`text-[20px] font-['GongGothicMedium'] md:text-[24px] ${txtGradientClass2}`}
                                >
                                    사우스캐슬
                                </p>
                                <p className="text-[18px] font-['GongGothicLight'] md:text-[20px]">
                                    성남시청 직장인 밴드 <br />
                                    사우스 캐슬입니다
                                </p>
                            </div>
                        </li>
                        <li className="w-full md:w-[calc(50%-10px)] xl:w-[calc(25%-15px)] flex flex-col">
                            <img src={programStageCont7Day2Img2} alt="이미지" className="w-full" />
                            <div className="flex-1 bg-[#F1F4F9] p-[20px] flex flex-col gap-[8px] text-center md:p-[20px_10px]">
                                <p
                                    className={`text-[20px] font-['GongGothicMedium'] md:text-[24px] ${txtGradientClass2}`}
                                >
                                    대환장 밴드
                                </p>
                                <p className="text-[18px] font-['GongGothicLight'] md:text-[20px]">
                                    어쩌다 보니 이렇게 되었습니다. <br />
                                    대환장 밴드
                                </p>
                            </div>
                        </li>
                        <li className="w-full md:w-[calc(50%-10px)] xl:w-[calc(25%-15px)] flex flex-col">
                            <img src={programStageCont7Day2Img3} alt="이미지" className="w-full" />
                            <div className="flex-1 bg-[#F1F4F9] p-[20px] flex flex-col gap-[8px] text-center md:p-[20px_10px]">
                                <p
                                    className={`text-[20px] font-['GongGothicMedium'] md:text-[24px] ${txtGradientClass2}`}
                                >
                                    M8
                                </p>
                                <p className="text-[18px] font-['GongGothicLight'] md:text-[20px]">
                                    Mate의 M에 영원의 8을 더한 <br />
                                    M8입니다. 재밌게 놉시다.
                                </p>
                            </div>
                        </li>
                        <li className="w-full md:w-[calc(50%-10px)] xl:w-[calc(25%-15px)] flex flex-col">
                            <img src={programStageCont7Day2Img4} alt="이미지" className="w-full" />
                            <div className="flex-1 bg-[#F1F4F9] p-[20px] flex flex-col gap-[8px] text-center md:p-[20px_10px]">
                                <p
                                    className={`text-[20px] font-['GongGothicMedium'] md:text-[24px] ${txtGradientClass2}`}
                                >
                                    컴투스 밴드
                                </p>
                                <p className="text-[18px] font-['GongGothicLight'] md:text-[20px]">
                                    컴투스 사내 밴드 <br />
                                    동호회에서 왔습니다.
                                </p>
                            </div>
                        </li>
                        <li className="w-full md:w-[calc(50%-10px)] xl:w-[calc(25%-15px)] flex flex-col">
                            <img src={programStageCont7Day2Img5} alt="이미지" className="w-full" />
                            <div className="flex-1 bg-[#F1F4F9] p-[20px] flex flex-col gap-[8px] text-center md:p-[20px_10px]">
                                <p
                                    className={`text-[20px] font-['GongGothicMedium'] md:text-[24px] ${txtGradientClass2}`}
                                >
                                    지수와로그
                                </p>
                                <p className="text-[18px] font-['GongGothicLight'] md:text-[20px]">
                                    한로로라는 가수의 노래를 <br />
                                    커버하는 밴드입니다.
                                </p>
                            </div>
                        </li>
                        <li className="w-full md:w-[calc(50%-10px)] xl:w-[calc(25%-15px)] flex flex-col">
                            <img src={programStageCont7Day2Img6} alt="이미지" className="w-full" />
                            <div className="flex-1 bg-[#F1F4F9] p-[20px] flex flex-col gap-[8px] text-center md:p-[20px_10px]">
                                <p
                                    className={`text-[20px] font-['GongGothicMedium'] md:text-[24px] ${txtGradientClass2}`}
                                >
                                    ED12
                                </p>
                                <p className="text-[18px] font-['GongGothicLight'] md:text-[20px]">
                                    안 해본 게 없다. 이제 <br />
                                    밴드만 남았다. ED12 Forever
                                </p>
                            </div>
                        </li>
                        <li className="w-full md:w-[calc(50%-10px)] xl:w-[calc(25%-15px)] flex flex-col">
                            <img src={programStageCont7Day2Img7} alt="이미지" className="w-full" />
                            <div className="flex-1 bg-[#F1F4F9] p-[20px] flex flex-col gap-[8px] text-center md:p-[20px_10px]">
                                <p
                                    className={`text-[20px] font-['GongGothicMedium'] md:text-[24px] ${txtGradientClass2}`}
                                >
                                    T.O.N.E
                                </p>
                                <p className="text-[18px] font-['GongGothicLight'] md:text-[20px]">
                                    판교 게임업계 소속 <br />
                                    직장인 밴드입니다.
                                </p>
                            </div>
                        </li>
                        <li className="w-full md:w-[calc(50%-10px)] xl:w-[calc(25%-15px)] flex flex-col">
                            <img src={programStageCont7Day2Img8} alt="이미지" className="w-full" />
                            <div className="flex-1 bg-[#F1F4F9] p-[20px] flex flex-col gap-[8px] text-center md:p-[20px_10px]">
                                <p
                                    className={`text-[20px] font-['GongGothicMedium'] md:text-[24px] ${txtGradientClass2}`}
                                >
                                    인데놀 168
                                </p>
                                <p className="text-[18px] font-['GongGothicLight'] md:text-[20px]">
                                    감각적인 사운드로 무대를 <br />
                                    채우는 INDENOL 168입니다.
                                </p>
                            </div>
                        </li>
                        <li className="w-full md:w-[calc(50%-10px)] xl:w-[calc(25%-15px)] flex flex-col">
                            <img src={programStageCont7Day2Img9} alt="이미지" className="w-full" />
                            <div className="flex-1 bg-[#F1F4F9] p-[20px] flex flex-col gap-[8px] text-center md:p-[20px_10px]">
                                <p
                                    className={`text-[20px] font-['GongGothicMedium'] md:text-[24px] ${txtGradientClass2}`}
                                >
                                    AOB
                                </p>
                                <p className="text-[18px] font-['GongGothicLight'] md:text-[20px]">
                                    익숙함, 그 너머의 색다름을 <br />
                                    추구하는 NC 최장수 밴드입니다.
                                </p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        ),
    },
    {
        title: "GXG 버스킹 타임 - 일러스타 페스",
        background: "bg-program202501",
        img: icProgramStage,
        contents: (
            <div className="flex flex-col gap-[16px] md:gap-[40px]">
                <div className="flex flex-col gap-[16px] md:gap-[40px] xl:flex-row xl:gap-0">
                    <ul className="flex flex-col gap-[16px] md:gap-[24px] xl:flex-1">
                        <li className="flex items-center gap-[8px] md:gap-[20px]">
                            <p className={txtBoxClass}>일시</p>
                            <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                                Day 1 : 9/19(금), 14:00 ~ 15:00 <br />
                                Day 2 : 9/20(토), 15:30 ~ 16:00
                            </p>
                        </li>
                        <li className="flex items-center gap-[8px] md:gap-[20px]">
                            <p className={txtBoxClass}>장소</p>
                            <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                                판교역 북측광장 B - 서브 스테이지
                            </p>
                        </li>
                        <li className="flex items-start gap-[8px] md:gap-[20px] md:items-center">
                            <p className={txtBoxClass}>내용</p>
                            <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                                서브컬처 트렌드의 중심, <br className="md:hidden" />
                                일러스타 페스의 디제잉과 랜덤플레이 댄스가 함께하는 <br />
                                미니 프로그램을 즐겨보세요!
                            </p>
                        </li>
                        <li className="flex items-center gap-[8px] md:gap-[20px]">
                            <p className={txtBoxClass}>9/19(금)</p>
                            <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                                일러스타 DJ 커넥트 쁘띠 - 라티
                            </p>
                        </li>
                        <li className="flex items-center gap-[8px] md:gap-[20px]">
                            <p className={txtBoxClass}>9/20(토)</p>
                            <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                                일러스아 DJ 커넥트 쁘띠 - Kizan
                            </p>
                        </li>
                    </ul>
                    <div className="w-full md:w-[calc(50%-10px)] xl:w-1/3">
                        <img src={programStageCont8Img1} alt="이미지" className="w-full" />
                    </div>
                </div>
                {/* <ul className="flex flex-wrap gap-[8px] md:gap-[20px]">
                    <li className="w-[calc(50%-4px)] md:w-[calc(50%-10px)] xl:w-[calc(33.333%-13.333px)]">
                        <img src={programStageCont8Img2} alt="이미지" className="w-full" />
                    </li>
                    <li className="w-[calc(50%-4px)] md:w-[calc(50%-10px)] xl:w-[calc(33.333%-13.333px)]">
                        <img src={programStageCont8Img3} alt="이미지" className="w-full" />
                    </li>
                </ul> */}
            </div>
        ),
    },
];

export default function Stage() {
    return (
        <>
            <div className="flex flex-col gap-[12px] p-[48px_0_20px] md:gap-[16px] xl:pt-[60px] xl:flex-row xl:items-center xl:justify-between">
                <SubTitle title="TIME TABLE" />
                <p className="text-[12px] font-['GongGothicLight'] md:text-[18px] xl:text-[24px]">
                    * 프로그램 구성 및 시간은 현장 상황에 따라 변동될 수 있습니다.
                </p>
            </div>
            <div className="hidden xl:block">
                <img src={programStageTimeTable} alt="이미지" />
            </div>
            <div className="xl:hidden">
                <ImgZoomPop img={programStageTimeTableTb} />
            </div>
            <div className="flex flex-col gap-[12px] p-[48px_0_20px] md:gap-[16px] xl:pt-[60px] xl:flex-row xl:items-center xl:justify-between">
                <SubTitle title="MAIN STAGE" />
                <p className="text-[12px] font-['GongGothicLight'] md:text-[18px] xl:text-[24px]">
                    * 프로그램 구성 및 시간은 현장 상황에 따라 변동될 수 있습니다.
                </p>
            </div>
            <ProgramAccordion
                list={programList}
                triggerClassName="justify-start gap-[8px] pl-[12px] md:pl-[20px] md:gap-[28px] [&>p]:text-[18px] [&>p]:md:text-[32px]"
                contentClassName="p-[20px_0] md:p-[40px_0] xl:p-[40px]"
            />
            <div className="flex flex-col gap-[12px] p-[48px_0_20px] md:gap-[16px] xl:pt-[60px] xl:flex-row xl:items-center xl:justify-between">
                <SubTitle title="SUB STAGE" />
                <p className="text-[12px] font-['GongGothicLight'] md:text-[18px] xl:text-[24px]">
                    * 프로그램 구성 및 시간은 현장 상황에 따라 변동될 수 있습니다.
                </p>
            </div>
            <ProgramAccordion
                list={programList2}
                triggerClassName="justify-start gap-[8px] pl-[12px] md:pl-[20px] md:gap-[28px] [&>p]:text-[18px] [&>p]:md:text-[32px]"
                contentClassName="p-[20px_0] md:p-[40px_0] xl:p-[40px]"
            />
        </>
    );
}
